import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import './index.css'

class GlobalLoader extends Component {
  static defaultProps = {
    showLoader: false
  }

  static propTypes = {
    showLoader: PropTypes.bool.isRequired
  }

  render () {
    return (
      <div className={`${this.props.showLoader ? ' fs-loader--visible ' : ' fs-loader '}`} id='fs-loader'>
        <div className='loader'>
          <p>loading...</p>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  showLoader: state.app.show_loader
})

export default connect(
  mapStateToProps,
  null
)(GlobalLoader)
